// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2OuZs","info":"Note_info__RGJ16","note":"Note_note__1w0Zh","actions":"Note_actions___gp4M"};